<template>
    <div>
        <b-modal
            id="comment-popup"
            ref="modal"
            title="Comment Popup"
            size="sm"
            no-close-on-backdrop
            no-close-on-esc
            modal-class="hide-footer"
            hide-footer
            :hide-header-close="loading"
            @hidden="onHidden"
        >
            <b-form
                @submit.stop.prevent="onSubmit()"
                @reset.stop.prevent="onHidden"
            >
                <div class="row custom-model-form">
                    <div class="col-md-12">
                        
                        <div class="form-group">
                            <div class="mb-3 checkbox-invalid"
                            v-if="isMultiOption()">
                                <p>Please select the document you want to reject</p>
                                <b-form-checkbox-group v-model="selectedCheckboxes"
                                name="checkbox"
                                v-validate="{
                                    required: !hasSelectedOption,
                                }"
                                  :class="{
                                    'is-invalid':errors.has('checkbox'),
                                }"
                                >
                                <b-form-checkbox 
                                v-for="(option, key) in options" :key="key" :value="key">{{ option }}</b-form-checkbox>
                                </b-form-checkbox-group>
                                <!-- <span v-if="!hasSelectedOption">Please select at least one option.</span> -->
                            </div>
                            <label for="comment">Comments</label>
                            <textarea
                                v-model="formData.comments"
                                v-validate="{
                                    required: true,
                                }"
                                name="comments"
                                class="form-control"
                                placeholder="Start typing your Comments"
                                rows="3"
                                :class="{
                                    'is-invalid': errors.has('comments'),
                                }"
                            ></textarea>
                            <p>Note that your comments will be included in the rejection email sent to the Customer.</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-12 action-buttons">
                    <base-button
                        btn-label="Submit"
                        btn-type="submit"
                        btn-variant="primary"
                        :class="loading || fileLoading ? 'disabled' : ''"
                    ></base-button>
                    <base-button
                        btn-label="Cancel"
                        btn-type="reset"
                        :disabled="loading"
                        btn-variant="link"
                    ></base-button>
                </div>
            </b-form>
        </b-modal>
    </div>
</template>

<script>
import tags from '@/components/Tags.vue'
import dateTimePicker from '@/components/DateTimePicker.vue'
import { mapGetters } from 'vuex'
import resource from '@/api/resource'
// import Radio from "../registration/Radio";

export default {
    props:{
     options:{
        type:Object,
        required:false
     }
    },
    /*
    |--------------------------------------------------------------------------
    | Component > components
    |--------------------------------------------------------------------------
    */
    components: {
        // Radio,
        // tags,
        // dateTimePicker,
    }, // End of Component > components

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters([
            'loading',
            'dataSegmentId',
            'kycRole',
            'alertRecord',
            'hidePopup',
            'customerRecord',
            'fileLoading',
        ]),
        hasSelectedOption() {
          return this.selectedCheckboxes.length > 0;
    },
    }, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    watch: {
        selectedCheckboxes(newValue) {
            // Emit an array with keys of checked options
            // console.log("new values",newValue)
            this.formData.keyArray = newValue
            // this.$emit('checkboxesSelected', newValue);
       },
        // alertRecord(value) {
        //     if (value) {
        //         this.formData.id = value._id
        //     }
        // },

        /**
         * Handle when the popup hide
         *
         * @return {void}
         */
        // hidePopup(val) {
        //     if (val) {
        //         this.onHidden()
        //     }
        // },
    }, // End of Component > watch

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            // dateUpdate: this.$moment().format('MMM D, YYYY h:mm a'),
            formData: this.initializeFormData(),
            selectedCheckboxes: [], 
            tempCountry: process.env.VUE_APP_COUNTRY_TEMP,
            // statusOptions: [],
            // tags: [],
        }
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {}, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        isMultiOption(){
            if(Object.keys(this.options).length>1){
             return true
           }else{
            return false
           }
        },
        isTwoDocsCountry(){
            let tempCountries = ['UAE','Qatar']
           if(tempCountries.includes(process.env.VUE_APP_COUNTRY_TEMP)){
             return true
           }else{
            return false
           }
        },
        initializeFormData() {
            console.log("Object.keys(this.options)[0]",Object.keys(this.options)[0])
            return {
              keyArray: !this.isMultiOption() ? [Object.keys(this.options)[0]]:[],
              comments: '',              
            }
        }, // End of initializeFormData() methods

        async onSubmit() {
            const result = await this.$validator.validateAll()
            // this.formData.dataSegmentId = localStorage.getItem(
            //     'activeDataSegmentId'
            // )

            // this.formData.customerId = this.$route.params.id
            // this.formData.kycStatus =
            //     this.formData.kycStatus == 're-submit'
            //         ? 'pending'
            //         : this.formData.kycStatus
            if (result) {
                try {
                   
                        this.$store.commit('setLoading',true)
                        this.$emit("commentSubmit",this.formData)
                    
                } catch (error) {
                    this.$store.commit('setLoading', false)
                    this.$store.commit('setError', error)
                    console.log(error, 'There is an error on submit')
                }
            }
        }, // End of onSubmit() method

        /**
         * Handle when the modal is closed
         *
         * @return {void}
         */
        onHidden() {
            // clear the selected item
            this.$store.commit('clearItem')
            Object.assign(this.formData, this.initializeFormData())
            this.selectedCheckboxes= []
            this.tags = []
            this.statusOptions = []
            this.$validator.reset()
            this.$refs.modal.hide()
        }, // End of onHidden() method

        setCustomerDetails() {
            if (this.customerRecord && this.customerRecord.kycSummary) {
                this.statusOptions = [
                    // { text: 'Pending Review', value: 'pending' },
                    { text: 'Accepted', value: 'approved' },
                    { text: 'Rejected', value: 'rejected' },
                    // { text: 'Re-submit documents', value: 're-submit' },
                ]
                if (
                    localStorage.getItem('isLeastRole') &&
                    localStorage.getItem('isLeastRole') == 'false'
                ) {
                    this.statusOptions.push({
                        text: 'Return Alert',
                        value: 'return-alert',
                    })
                }
                this.tags.push({
                    headings: this.customerRecord.kycSummary.riskRating,
                    icon: 'icon-graph',
                    actions: this.customerRecord.kycSummary.riskRating,
                })
                this.formData.riskRating =
                    this.customerRecord.kycSummary.riskRating
            }
        }, // End of setCustomerDetails() method
    }, // End of Component > mounted
}
</script>
